import React, { useEffect, useState } from 'react';
import { Alert } from '../../components';
export const AlertsManager = _ref => {
  let {
    manager
  } = _ref;
  const [alert, setAlert] = useState(null);
  useEffect(() => manager.subscribe(setAlert), [manager]);
  return alert ? /*#__PURE__*/React.createElement(Alert, alert) : null;
};